<template>
	<div class="app-main-navigation height-100" :class="{ collapsed: isSidebarCollapsed }">
		<div class="upper-navigation">
			<div
				:class="{ collapsed: isSidebarCollapsed }"
				class="display-flex flex-row flex-align-center flex-justify-space-between header-container"
			>
				<SIcon class="navigation-logo" :name="`ply-logo${isSidebarCollapsed ? '-no-text' : ''}`" :width="50" :height="22" />
				<AppTooltip position="right" :text="`${isSidebarCollapsed ? 'Expand' : 'Collapse'} menu`">
					<AnemicButton
						tile
						small
						width="17"
						height="17"
						@click="toggleSidebarCollapseState"
						:class="{ 'ml-n9': isSidebarCollapsed }"
						class="collapse-button suffix-component-container"
					>
						<SIcon :class="{ rotate: isSidebarCollapsed }" name="collapse-sidebar" :width="20" :height="17" />
					</AnemicButton>
				</AppTooltip>
			</div>
			<NavigationButtonsList :isSidebarCollapsed="isSidebarCollapsed" :navItems="primaryNavItems" />
			<div class="navigation-separator mx-2 my-2" />
			<NavigationAccordionsList class="px-2" :accordionsList="accordionsNavItems" />
		</div>
		<div class="bottom-navigation">
			<NavigationButtonsList :isSidebarCollapsed="isSidebarCollapsed" :navItems="secondaryNavItems" />
			<UserMenu :isSidebarCollapsed="isSidebarCollapsed" class="mx-2" />
		</div>
	</div>
</template>

<script>
import { useInboxes } from '@/store/modules/inboxes/getters';
import { fetchInboxes } from '@/store/modules/inboxes/actions';
import UserMenu from '@/views/AppLayout/AppNavigation/UserMenu.vue';
import NavigationAccordionsList from './NavigationAccordionsList.vue';
import { userOnBoardingMetadata } from '@/store/modules/auth/getters';
import NavigationButtonsList from './common/NavigationButtonsList.vue';
import { useIsSidebarCollapsed } from '@/store/modules/appLayout/getters';
import { setIsSidebarCollapsed } from '@/store/modules/appLayout/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { SECONDARY_NAVIGATION_ITEMS, PRIMARY_NAVIGATION_ITEMS, getAccordionNavItems } from './app-navigation.const';
export default {
	name: 'AppMainNavigation',
	components: { UserMenu, NavigationButtonsList, NavigationAccordionsList },
	computed: {
		...mapGettersShorthand({ isSidebarCollapsed: useIsSidebarCollapsed, userOnBoardingMetadata, useInboxes }),
		accordionsNavItems() {
			return getAccordionNavItems({ useInboxesGetter: this.useInboxes, fetchInboxesAction: this.fetchInboxes });
		},
	},
	methods: {
		...mapActionsShorthand({ fetchInboxes, setIsSidebarCollapsed }),
		toggleSidebarCollapseState() {
			this.setIsSidebarCollapsed({ isCollapsed: !this.isSidebarCollapsed });
		},
	},
	mounted() {
		this.accordionsNavItems.forEach(({ requiredAction }) => requiredAction());
	},
	data: () => ({
		primaryNavItems: PRIMARY_NAVIGATION_ITEMS,
		secondaryNavItems: SECONDARY_NAVIGATION_ITEMS,
	}),
};
</script>

<style lang="scss">
.app-main-navigation {
	display: flex;
	flex-direction: column;
	background: var(--bg-color);
	justify-content: space-between;
	border-radius: 0px 6px 6px 0px;

	&:hover {
		.suffix-component-container {
			//this class is in NavigationButtonsList.vue
			opacity: 1 !important;
			transition: 0.3s !important;
		}
	}
	&.collapsed {
		&:hover {
			.navigation-logo {
				opacity: 0;
				visibility: hidden;
				width: 0px !important;
				transition: visibility 0.2s, opacity 0.2s linear;
			}
		}
	}
	.header-container {
		padding: 20px 12px 30px 22px;
		&.collapsed {
			padding-left: 20px;
		}
	}

	.upper-navigation,
	.bottom-navigation {
		display: flex;
		flex-direction: column;
	}
}
.collapse-button {
	border-radius: 6px;
	padding: 0px !important;
}
.suffix-component-container {
	opacity: 0;
	transition: 0.2s;
}
.rotate {
	transition: 0.3s;
	transform: rotate(180deg);
}
.space-from-logo {
	top: 60px;
	margin-left: 28px;
	position: absolute;
}
.navigation-separator {
	border-bottom: 1px solid var(--border-color);
}
</style>
